import { MutationCache, QueryCache } from '@tanstack/react-query';

import { isExpectedApiError, reportGlobalApiError } from '../helpers/api-errors';

export const QueryClientConfig = {
  // Present permission (403), session-expiry (401) and disabled-store (402)
  // failures once, no matter which query or mutation hit them — including loaders
  // and any hook that doesn't wire its own onError. The first two become a single
  // toast, 402 becomes the route takeover. reportGlobalApiError leaves every other
  // error to each hook's existing handler.
  queryCache: new QueryCache({ onError: reportGlobalApiError }),
  mutationCache: new MutationCache({ onError: reportGlobalApiError }),
  defaultOptions: {
    queries: {
      // Show cached data immediately if available
      placeholderData: (previousData: unknown) => previousData,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      // Retrying a permission/session/store-disabled failure just replays the
      // same rejection, so fail fast on those and keep the two-retry budget for
      // transient errors.
      retry: (failureCount: number, error: Error) => !isExpectedApiError(error) && failureCount < 2,
    },
  },
};

export const QUERY_CLIENT_MAX_AGE = 3 * 24 * 60 * 60 * 1000; // 3 days max age
